module.exports = __webpack_public_path__ + "static/FAQ-banner1-8dfb5db21f53933a47130ae130996dbe.jpg";